export const FLUX_3_VIDEO_MODEL = 'blackforestlabs/flux-3/text-to-video';
export const FLUX_3_MAX_VARIANT = 'Max';
export const FLUX_3_DEFAULT_DURATION = 10;
